//changed due to package upgrade
import React, { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import IntlMessages from '@projectK/helpers/IntlMessages';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import AppGridContainer from '@projectK/components/AppGridContainer';
import {
  alpha,
  Autocomplete,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
} from '@mui/material';
import { Field, Form, Formik } from 'formik';
import { useInfoViewActionsContext } from '@projectK/context/InfoViewContextProvider';
import jwtAxios from '@projectK/services/auth/JWT';
import { CloseRounded } from '@mui/icons-material';
import { DateTime } from 'luxon';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import { AiOutlineDelete } from 'react-icons/ai';
import { useApplicationSettings } from '@projectK/context/VerbiageContextProvider';
import PropTypes from 'prop-types';
import AppModalConfirmation from '@projectK/components/AppModalConfirmation';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import { isAdmin, isSuperAdmin } from '@projectK/context/RolesProvider';

const AddAttendance = ({
  isOpen,
  onClose,
  activityData,
  sessionId,
  productId,
  fetchAttendanceData,
  isFetch,
  reportId,
  attendanceData,
  fetchData,
  fetchSignUpUsers,
  signUpUsers,
  setPerPage,
  handleReportsData,
}) => {
  const isSmallDevice = useMediaQuery('(max-width:600px)');
  const companyTheme = CompanyTheme();
  const { verbiageSettings } = useApplicationSettings();
  const infoViewActionsContext = useInfoViewActionsContext();
  const [checkAll, setCheckAll] = useState(false);
  const [reportFields, setReportFields] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const { user } = useAuthUser();
  useEffect(() => {
    fetchReportFields();
  }, [reportId]);

  const fetchReportFields = async () => {
    if (reportId) {
      try {
        setLoading(true);
        const response = await jwtAxios.get(
          `/report-fields/report/${reportId}`,
        );
        const { data } = response;
        setReportFields(data.list);
        setLoading(false);
      } catch (error) {
        setReportFields([]);
        setLoading(false);
      }
    }
  };
  const handleSelectAll = (e, setFieldValue) => {
    const { checked } = e.target;
    const allCheckedAttendence = {};
    signUpUsers.forEach((user, index) => {
      setFieldValue(`is_attended[${index}].is_attended${index}`, checked);
      allCheckedAttendence[user.id] = checked;
    });
    setAllAttendence({ ...allCheckedAttendence });
  };

  const formatStartDateTimeRange = (startDate, startTime) => {
    const formattedStartDate = new Date(
      `${startDate?.substring(0, 10)}T12:01:00`,
    ).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });

    const formattedStartTime = new Date(
      `1970-01-01T${startTime}`,
    ).toLocaleString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    });

    return (
      <div>
        {formattedStartDate}&nbsp;&nbsp;&nbsp;
        {formattedStartTime}
      </div>
    );
  };
  const formatEndDateTimeRange = (endDate, endTime) => {
    const formattedEndDate = new Date(
      `${endDate?.substring(0, 10)}T12:01:00`,
    ).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });

    const formattedEndTime = new Date(`1970-01-01T${endTime}`).toLocaleString(
      'en-US',
      {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      },
    );

    return (
      <div>
        {formattedEndDate}&nbsp;&nbsp;&nbsp;
        {formattedEndTime}
      </div>
    );
  };
  const [selectedUser, setSelectedUser] = useState(null);
  const [userReportData, setUserReportData] = useState(null);
  const [feedbackData, setFeedbackData] = useState([]);
  // Now you can set signUpUsers with the filtered data
  const [searchTermMember, setSearchTermMember] = useState(null);

  const [users, setUsers] = useState([]);
  const [allAttendence, setAllAttendence] = useState({});
  const [allReportFields, setAllReportFields] = useState({});
  const [feedbackValues, setFeedbackValues] = useState({});
  const handleChangeAllAttendence = (key, value) => {
    setAllAttendence((prev) => ({
      ...prev,
      [`${key}`]: value,
    }));
  };
  useEffect(() => {
    fetchUsersData();
  }, [searchTermMember]);

  useEffect(() => {
    handleRerportsData();
    fetchFeedbackData();
    fetchAttendanceData();
  }, []);

  const fetchUsersData = async () => {
    try {
      const response = await jwtAxios.get(
        `/attendance/eligible-students/${sessionId}`,
        {
          params: {
            search: searchTermMember,
          },
        },
      );
      const { data } = response;
      setUsers(data?.list);
    } catch (error) {
      console.error('error', error);
      setUsers([]);
    }
  };
  setPerPage('all');
  const [creditWarningOpen, setCreditWarningOpen] = useState(false);
  const [creditWarningMessage, setCreditWarningMessage] = useState('');

  const performMemberSessionSignup = async () => {
    setCreditWarningOpen(false);
    setCreditWarningMessage('');
    try {
      setLoading(true);
      await jwtAxios.post(`/user-session/admin/user_session`, {
        user_id: selectedUser?.id,
        activity_session_id: activityData?.id,
        product_id: activityData?.product_id,
      });
      infoViewActionsContext.showMessage(
        'Signed up to a session successfully!',
      );
      setSelectedUser(null);
      setSearchTermMember(null);
      setInputValue('');
      fetchSignUpUsers();
      fetchAttendanceData();
      fetchUsersData();
    } catch (error) {
      if (error.response.data.isNegative) {
        setCreditWarningOpen(true);
        setCreditWarningMessage(error?.response?.data?.error);
      } else {
        infoViewActionsContext.fetchError(error?.response?.data?.error);
      }
    } finally {
      setLoading(false);
    }
  };
  const isAdminUser = (user) => isSuperAdmin(user) || isAdmin(user);

const hasCredits = (creditBalance) =>
  creditBalance !== undefined && creditBalance !== null;

const getCreditWarningMessage = ({
  creditBalance,
  creditCost,
  isAdminUser,
}) => {
  if (!hasCredits(creditBalance) || creditBalance === '∞') return '';

  const numericBalance = Number(creditBalance);
  if (Number.isNaN(numericBalance)) return '';

  if (numericBalance < 0) {
    return `This student currently has a negative credit balance. ${
      isAdminUser
        ? 'Do you want to add this student?'
        : 'Please have them speak with an administrator before continuing.'
    }`;
  }

  if (creditCost > 0 && numericBalance < creditCost) {
    return `This student does not have enough credits to attend this session. ${
      isAdminUser
        ? 'Do you want to add this student?'
        : 'Please contact an administrator before continuing.'
    }`;
  }

  return '';
};

const handleMemberSessionSignup = () => {
  if (!selectedUser) return;

  const creditBalance = selectedUser?.credit_balance;
  const creditCost = parseFloat(activityData?.credit_cost || 0);

  const message = getCreditWarningMessage({
    creditBalance,
    creditCost,
    isAdminUser: isAdminUser(user),
  });

  if (message) {
    setCreditWarningMessage(message);
    setCreditWarningOpen(true);
    return;
  }

  performMemberSessionSignup();
};
  const [inputValue, setInputValue] = useState('');

  const handleUserChange = (event, newValue) => {
    setSelectedUser(newValue);
  };

  const handleInputChange = (event, newInputValue) => {
    setInputValue(newInputValue);
    setSearchTermMember(newInputValue);
  };
  const handleClose = () => {
    if (fetchData) {
      fetchData();
    }
    setCheckAll(false);
  };
  const handleCancelUp = async (user_id, id, product_id) => {
    try {
      setLoading(true);
      // Make the Delete request using jwtAxios
      await jwtAxios.delete(`/user-session`, {
        params: {
          user_id: user_id,
          activity_session_id: id,
          product_id: product_id,
          report_id: reportId,
        },
      });
      fetchSignUpUsers();

      setLoading(false);
      infoViewActionsContext.showMessage(`Cancelled session successfully`);
    } catch (error) {
      infoViewActionsContext.fetchError(error.response.data.error);
    }
  };

  const handleRerportsData = async () => {
    try {
      setLoading(true);
      const response = await jwtAxios.get(
        `/user-reports-data/session/${sessionId}`,
      );
      const { data } = response;
      setUserReportData(data.list);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      infoViewActionsContext.fetchError(error.response.data.error);
    }
  };

  const fetchFeedbackData = async () => {
    try {
      setLoading(true);
      const response = await jwtAxios.get(
        `/user-feedback/session/${sessionId}`,
        {
          params: {
            perPage: 'all',
          },
        },
      );
      const { data } = response;
      setFeedbackData(data.list);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('An error occurred:', error);
    }
  };

  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [userIdToDelete, setUserIdToDelete] = useState(null);
  const handleDelete = (userId, selectedSessionId, selectedProductId) => {
    setUserIdToDelete(userId);
    setDeleteConfirmationOpen(true);
  };
  const handleConfirmDelete = () => {
    handleCancelUp(userIdToDelete, sessionId, productId);
    setDeleteConfirmationOpen(false);
  };

  const handleCancelDelete = () => {
    setDeleteConfirmationOpen(false);
  };

  // Construct the is_attended array
  const isAttendedArray = signUpUsers?.map((data, index) => {
    const attendanceValue = attendanceData?.filter(
      (entry) => entry?.user_id === data?.id,
    );
    let isAttended;
    if (allAttendence[`${data?.id}`] !== undefined) {
      isAttended = allAttendence[`${data?.id}`];
    } else {
      isAttended =
        attendanceValue?.length > 0
          ? Boolean(attendanceValue[0].is_attended)
          : false;
    }

    return { [`is_attended${index}`]: isAttended };
  });

  const fieldsInitialArray = signUpUsers?.map((data, index) => {
    const fieldvalue =
      reportFields[0] && userReportData
        ? userReportData[reportFields[0]?.report_id]?.filter(
            (entry) => entry?.user_id === data?.id,
          )
        : [];

    return reportFields?.map((element) => {
      let field_value = '';
      const isAttended = isAttendedArray[index][`is_attended${index}`];

      if (isAttended) {
        const filteredValue = fieldvalue?.filter(
          (entry) => entry.report_field_id === element.report_field_id,
        );

        const key = `${data?.id}-${element?.report_field_id}`;
        const reportFieldValue = allReportFields?.[key];

        if (reportFieldValue) {
          field_value = reportFieldValue;
        } else if (filteredValue?.length > 0) {
          field_value = filteredValue[0].value;
        }
      }

      return {
        report_field_name: element.report_field_name,
        report_field_id: element.report_field_id,
        value: field_value,
      };
    });
  });
  const handleFieldChange = (e, ind, index, element, field, setFieldValue) => {
    const newValue = e.target.value;

    setFieldValue(`fields[${ind}][${index}].value`, newValue);

    setAllReportFields((prev) => ({
      ...prev,
      [`${element.id}-${field.report_field_id}`]: newValue,
    }));
  };
  const renderField = (field, index, ind, element, setFieldValue, values) => {
    const isDisabled = false;
    const fieldValue = values?.fields?.[ind]?.[index]?.value || '';

    return (
      <Grid size={{ xs: 12, md: 4 }} key={field.report_field_name}>
        <TextField
          name={`fields[${ind}][${index}].value`}
          value={fieldValue}
          onChange={(e) =>
            handleFieldChange(e, ind, index, element, field, setFieldValue)
          }
          variant='outlined'
          sx={{ width: '100%', marginBottom: '10px' }}
          label={field.report_field_name}
          disabled={isDisabled}
        />
        <input
          type='hidden'
          name={`fields[${ind}][${index}].report_field_id`}
          value={field.report_field_id}
        />
      </Grid>
    );
  };
  // Construct the feedback array
  const feedbackArray = signUpUsers.map((data) => {
    const feedbackvalue = feedbackData?.filter(
      (entry) => entry.user_id === data.id,
    );

    if (feedbackValues?.[data.id]) {
      return feedbackValues[data.id];
    }

    if (feedbackvalue?.length > 0) {
      return feedbackvalue[0].feedback;
    }

    return '';
  });

  const handleFeedbackChange = (e, ind, element, setFieldValue) => {
    const newValue = e.target.value;

    setFieldValue(`feedback.${ind}`, newValue);

    setFeedbackValues((prev) => ({
      ...prev,
      [element.id]: newValue,
    }));
  };
  // Final initialValues
  const initialValues = {
    is_attended: isAttendedArray,
    fields: fieldsInitialArray,
    feedback: feedbackArray,
    user_id: '',
    attendance_date: activityData.start_date,
    activity_session_id: parseInt(sessionId),
    report_id: activityData.report_id,
    activity_id: activityData.activity_id,
  };
  const handleDialogOpen = () => {
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleCloseModalDialog = () => {
    setOpenDialog(false); // to close the dialog
    handleModalClose(); //to close the modal
  };
  const handleModalClose = () => {
    handleClose();
    onClose();
  };
  return (
    <>
      {!loading && (
        <Modal open={isOpen} onClose={handleDialogOpen}>
          <Box
            className='p-popup'
            sx={{
              bgcolor: 'background.paper',
            }}
          >
            <Formik
              enableReinitialize
              initialValues={initialValues}
              onSubmit={async (values, { setSubmitting }) => {
                const { fields, feedback, user_id, ...rest } = values;
                try {
                  await Promise.all(
                    signUpUsers.map(async (data, index) => {
                      const requestData = {
                        ...rest,
                        user_id: data?.id,
                        is_attended: checkAll
                          ? true
                          : values.is_attended[index][`is_attended${index}`],
                        attendance_date: new Date(values.attendance_date)
                          .toISOString()
                          .substring(0, 10),
                      };

                      fields[index].forEach((field) => {
                        if (!field.value) {
                          field.value = null;
                        }
                      });
                      if (!feedback[index]) {
                        feedback[index] = null;
                      }

                      const feedbackdata = {
                        feedback: feedback[index],
                        feedback_date: new Date(values.attendance_date)
                          .toISOString()
                          .substring(0, 10),
                        activity_session_id: sessionId,
                        activity_id: activityData.activity_id,
                        user_id: data?.id,
                      };
                      await jwtAxios.post(`/user-feedback`, feedbackdata);
                      infoViewActionsContext.showMessage(
                        'Feedback added successfully!',
                      );

                      await jwtAxios.post(`/attendance`, requestData);
                      setCheckAll(false);
                      if (isFetch) {
                        fetchAttendanceData();
                      }

                      infoViewActionsContext.showMessage(
                        'Attendance added successfully!',
                      );
                      if (values.report_id) {
                        const reportResponse = await jwtAxios.post(
                          `/user-reports`,
                          {
                            user_id: data?.id,
                            product_id: productId,
                            entry_date: new Date(values.attendance_date)
                              .toISOString()
                              .substring(0, 10),
                            report_id: values.report_id,
                            activity_session_id: sessionId,
                          },
                        );

                         const userReportId = reportResponse?.data?.id;
                         const isAttended =values?.is_attended[index][`is_attended${index}`];
                         const fieldsData = fields[index]?.map((field) => ({
                          report_field_id: field.report_field_id,
                          value: isAttended && field?.value !== null ? field.value : '',
                        }));

                        const reportsDataresponse = await jwtAxios.post(
                          `/user-reports-data`,
                          {
                            user_report_id: userReportId,
                            fields: fieldsData,
                            activity_session_id: rest.activity_session_id,
                          },
                        );

                        if (reportsDataresponse.status === 201) {
                          setSelectedUser(null);
                          handleCloseModalDialog();
                          infoViewActionsContext.showMessage(
                            'Attendance added successfully!',
                          );
                          fetchAttendanceData();
                        }
                      }
                      handleCloseModalDialog();
                      handleReportsData();
                      fetchAttendanceData();
                      fetchSignUpUsers();
                    }),
                  );
                } catch (error) {
                  infoViewActionsContext.fetchError(
                    error?.response?.data?.error,
                  );
                } finally {
                  setSubmitting(false);
                }
              }}
            >
              {({ setFieldValue, values, touched, isEdit, isSubmitting }) => {//NOSONAR
                const is_attendedValues = values.is_attended.map(
                  (obj) => Object.values(obj)[0],
                );
                const allChecked = is_attendedValues.every((value) => value);
                // Update the state of the main checkbox
                setCheckAll(allChecked);
                return (
                  <Form noValidate autoComplete='off' className='main'>
                    <Box
                      sx={{ display: 'flex', justifyContent: 'space-between' }}
                    >
                      <Box>
                        <Typography
                          variant='h4'
                          style={{
                            marginTop: '10px',
                            color: companyTheme
                              ? companyTheme.primary.main
                              : 'text.primary',
                          }}
                        >
                          Add Attendance
                        </Typography>
                      </Box>
                      <Box>
                        <IconButton
                          size='small'
                          sx={{ fontWeight: 'bold', color: '#000000' }}
                          className='icon-btn'
                          onClick={handleDialogOpen}
                        >
                          <CloseRounded />
                        </IconButton>
                      </Box>
                    </Box>
                    <AppGridContainer sx={{ mt: 2 }}>
                      <Grid size={{ xs: 12, md: 12 }}>
                        <Box
                          sx={{
                            border: '1px solid #EAECF0',
                            p: 6,
                            borderRadius: 3,
                            boxShadow:
                              '0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)',
                          }}
                        >
                          <AppGridContainer>
                            <Grid size={{ xs: 12, md: 12 }}>
                              <Grid container spacing={2}>
                                <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                                  <Typography variant='h4'>
                                    <Box display='flex' justifyContent='left'>
                                      <span>
                                        {verbiageSettings.product_type ||
                                          'Product'}{' '}
                                        Name
                                      </span>
                                    </Box>
                                  </Typography>
                                </Grid>
                                <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                                  <Typography variant='h4'>
                                    <Box display='flex' justifyContent='center'>
                                      <span>:</span>
                                    </Box>
                                  </Typography>
                                </Grid>
                                <Grid size={{ xs: 7 }} sx={{ my: 2 }}>
                                  <Typography
                                    variant='body1'
                                    sx={{ fontWeight: 'normal' }}
                                  >
                                    <Box
                                      display='flex'
                                      justifyContent='flex-start'
                                    >
                                      <span className='wordbreak'>
                                        {activityData.product_name}
                                      </span>
                                    </Box>
                                  </Typography>
                                </Grid>
                              </Grid>
                              <Grid container spacing={2}>
                                <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                                  <Typography variant='h4'>
                                    <Box display='flex' justifyContent='left'>
                                      <span>Activity Name</span>
                                    </Box>
                                  </Typography>
                                </Grid>
                                <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                                  <Typography variant='h4'>
                                    <Box display='flex' justifyContent='center'>
                                      <span>:</span>
                                    </Box>
                                  </Typography>
                                </Grid>
                                <Grid size={{ xs: 7 }} sx={{ my: 2 }}>
                                  <Typography
                                    variant='body1'
                                    sx={{ fontWeight: 'normal' }}
                                  >
                                    <Box
                                      display='flex'
                                      justifyContent='flex-start'
                                    >
                                      <span className='wordbreak'>
                                        {activityData.activity_name}
                                      </span>
                                    </Box>
                                  </Typography>
                                </Grid>
                              </Grid>
                              <Grid container spacing={2}>
                                <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                                  <Typography variant='h4'>
                                    <Box display='flex' justifyContent='left'>
                                      <span>Activity Display Name</span>
                                    </Box>
                                  </Typography>
                                </Grid>
                                <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                                  <Typography variant='h4'>
                                    <Box display='flex' justifyContent='center'>
                                      <span>:</span>
                                    </Box>
                                  </Typography>
                                </Grid>
                                <Grid size={{ xs: 7 }} sx={{ my: 2 }}>
                                  <Typography
                                    variant='body1'
                                    sx={{ fontWeight: 'normal' }}
                                  >
                                    <Box
                                      display='flex'
                                      justifyContent='flex-start'
                                    >
                                      <span className='wordbreak'>
                                        {activityData?.activity_display_name}
                                      </span>
                                    </Box>
                                  </Typography>
                                </Grid>
                              </Grid>
                              <Grid container spacing={2}>
                                <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                                  <Typography variant='h4'>
                                    <Box display='flex' justifyContent='left'>
                                      <span>Start Date/Time</span>
                                    </Box>
                                  </Typography>
                                </Grid>
                                <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                                  <Typography variant='h4'>
                                    <Box display='flex' justifyContent='center'>
                                      <span>:</span>
                                    </Box>
                                  </Typography>
                                </Grid>
                                <Grid size={{ xs: 7 }} sx={{ my: 2 }}>
                                  {' '}
                                  <Typography
                                    variant='body1'
                                    sx={{ fontWeight: 'normal' }}
                                  >
                                    <Box
                                      display='flex'
                                      justifyContent='flex-start'
                                    >
                                      <span>
                                        {formatStartDateTimeRange(
                                          activityData.start_date,
                                          activityData.start_time,
                                        )}
                                      </span>
                                    </Box>
                                  </Typography>
                                </Grid>
                              </Grid>
                              <Grid container spacing={2}>
                                <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                                  <Typography variant='h4'>
                                    <Box display='flex' justifyContent='left'>
                                      <span>End Date/Time</span>
                                    </Box>
                                  </Typography>
                                </Grid>
                                <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                                  <Typography variant='h4'>
                                    <Box display='flex' justifyContent='center'>
                                      <span>:</span>
                                    </Box>
                                  </Typography>
                                </Grid>
                                <Grid size={{ xs: 7 }} sx={{ my: 2 }}>
                                  <Typography
                                    variant='body1'
                                    sx={{ fontWeight: 'normal' }}
                                  >
                                    <Box
                                      display='flex'
                                      justifyContent='flex-start'
                                    >
                                      <span>
                                        {formatEndDateTimeRange(
                                          activityData.end_date,
                                          activityData.end_time,
                                        )}
                                      </span>
                                    </Box>
                                  </Typography>
                                </Grid>
                              </Grid>
                              <Grid container spacing={2}>
                                <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                                  <Typography variant='h4'>
                                    <Box display='flex' justifyContent='left'>
                                      <span>Facility Location</span>
                                    </Box>
                                  </Typography>
                                </Grid>
                                <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                                  <Typography variant='h4'>
                                    <Box display='flex' justifyContent='center'>
                                      <span>:</span>
                                    </Box>
                                  </Typography>
                                </Grid>
                                <Grid size={{ xs: 7 }} sx={{ my: 2 }}>
                                  <Typography
                                    variant='body1'
                                    sx={{ fontWeight: 'normal' }}
                                  >
                                    <Box
                                      display='flex'
                                      justifyContent='flex-start'
                                    >
                                      <span className='wordbreak'>
                                        {activityData.location_name}
                                      </span>
                                    </Box>
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid size={{ xs: 12, md: 4 }}>
                              <LocalizationProvider
                                dateAdapter={AdapterDateFns}
                              >
                                <Stack spacing={1}>
                                  <DatePicker
                                    disabled={true}
                                    label='Date'
                                    value={
                                      activityData.start_date
                                        ? new Date(activityData.start_date)
                                        : null
                                    }
                                    onChange={(newValue) => {
                                      if (newValue) {
                                        setFieldValue(
                                          'attendance_date',
                                          DateTime.fromJSDate(
                                            newValue,
                                          ).toFormat('yyyy-MM-dd'),
                                        );

                                        touched.date = true;
                                      } else {
                                        setFieldValue('attendance_date', '');
                                      }
                                    }}
                                    InputProps={{
                                      readOnly: !isEdit,
                                    }}
                                    name='date'
                                  />
                                </Stack>
                              </LocalizationProvider>
                            </Grid>
                            <Grid size={{ xs: 12, md: 5 }}>
                              <Autocomplete
                                freeSolo
                                id='free-solo-2-demo'
                                options={(users || []).sort((a, b) =>
                                  (
                                    a.first_name +
                                    ' ' +
                                    a.last_name
                                  ).localeCompare(
                                    b.first_name + ' ' + b.last_name,
                                    undefined,
                                    { numeric: true, sensitivity: 'base' },
                                  ),
                                )}
                                value={selectedUser}
                                onChange={handleUserChange}
                                inputValue={inputValue}
                                onInputChange={handleInputChange}
                                getOptionLabel={(option) =>
                                  `${option.first_name} ${option.last_name} - ${option.email}`
                                }
                                getOptionKey={(option) => option.id}
                                renderOption={(props, option) => (
                                  <li
                                    {...props}
                                    style={{
                                      color:
                                        option.is_deleted === 1
                                          ? 'red'
                                          : 'inherit',
                                    }}
                                  >
                                    {`${option.first_name} - ${option.last_name} - ${option.email}`}
                                  </li>
                                )}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label='Search user'
                                    name='user_id'
                                    value={inputValue}
                                    sx={{
                                      width: '100%',
                                      marginBottom: '10px',
                                    }}
                                    InputProps={{// NOSONAR - MUI v6 Autocomplete still requires InputProps for dropdown anchor
                                      ...params.InputProps,
                                    }}
                                  />
                                )}
                              />
                            </Grid>
                            <Grid size={{ xs: 12, md: 2 }}>
                              <Button
                                sx={{
                                  marginTop: isSmallDevice ? 0 : 2,
                                  position: 'relative',
                                  minWidth: 100,
                                  backgroundColor: companyTheme
                                    ? companyTheme.primary.main
                                    : '#2196f3',
                                  '&:hover': {
                                    backgroundColor: companyTheme
                                      ? alpha(companyTheme.primary.main, 0.8)
                                      : alpha('#2196f3', 0.8),
                                  },
                                }}
                                variant='contained'
                                onClick={() => {
                                  if (selectedUser) {
                                    handleMemberSessionSignup();
                                  }
                                }}
                              >
                                Add User
                              </Button>
                            </Grid>
                          </AppGridContainer>

                          <Divider sx={{ my: 4 }} />

                          <AppGridContainer>
                            <Grid size={{ xs: 12, md: 12 }}>
                              <Table
                                style={{
                                  display: isSmallDevice ? 'none' : 'table',
                                }}
                              >
                                <TableHead>
                                  <TableCell>
                                    <Typography>
                                      <b>Action</b>
                                    </Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Typography>
                                      <b>Name :</b>
                                    </Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Grid size={{ xs: 12, md: 12 }}>
                                      <Checkbox
                                        sx={{ marginLeft: '-15px' }}
                                        checked={checkAll}
                                        onChange={(e) =>
                                          handleSelectAll(e, setFieldValue)
                                        }
                                      />
                                    </Grid>
                                  </TableCell>
                                  <TableCell>
                                    <Typography>
                                      <b>Report Name : </b>{' '}
                                      {reportFields[0]?.report_name}
                                    </Typography>
                                  </TableCell>
                                </TableHead>
                                {signUpUsers.map((element, ind) => {
                                  return (
                                    <TableBody key={element.id}>
                                      <TableCell>
                                        <Grid container spacing={2}>
                                          <div
                                            style={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                            }}
                                          >
                                            <IconButton
                                              size='small'
                                              className='icon-btn'
                                              onClick={() =>
                                                handleDelete(
                                                  element.id,
                                                  sessionId,
                                                  productId,
                                                )
                                              }
                                            >
                                              <AiOutlineDelete />
                                            </IconButton>
                                          </div>
                                        </Grid>
                                      </TableCell>
                                      <TableCell>
                                        <Typography>
                                          {element?.first_name}&nbsp;
                                          {element?.last_name}
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Grid size={{ xs: 12, md: 12 }}>
                                          <FormControlLabel
                                            control={
                                              <Field
                                                component={Checkbox}
                                                type='checkbox'
                                                name={`is_attended${ind}`}
                                                id={`is_attended${ind}`}
                                                onChange={(e) => {
                                                  const isChecked =
                                                    e.target.checked;
                                                  setFieldValue(
                                                    `is_attended[${ind}].is_attended${ind}`,
                                                    e.target.checked,
                                                  );
                                                  handleChangeAllAttendence(
                                                    element.id,
                                                    e.target.checked,
                                                  );
                                                  setCheckAll(
                                                    isChecked
                                                      ? checkAll
                                                      : false,
                                                  );
                                                }}
                                                checked={
                                                  checkAll ||
                                                  (values.is_attended[ind]
                                                    ? values.is_attended[ind][
                                                        `is_attended${ind}`
                                                      ]
                                                    : false)
                                                }
                                              />
                                            }
                                          />
                                        </Grid>
                                      </TableCell>
                                      <TableCell>
                                        <Grid container spacing={2}>
                                          {reportFields?.map((field, index) =>
                                            renderField(
                                              field,
                                              index,
                                              ind,
                                              element,
                                              setFieldValue,
                                              values,
                                            ),
                                          )}
                                        </Grid>
                                        <Grid
                                          size={{ xs: 12, md: 12 }}
                                          style={{ marginTop: '10px' }}
                                        >
                                          <TextField
                                            name={`feedback.${ind}`}
                                            value={values?.feedback?.[ind]}
                                            onChange={(e) =>
                                              handleFeedbackChange(
                                                e,
                                                ind,
                                                element,
                                                setFieldValue,
                                              )
                                            }
                                            variant='outlined'
                                            sx={{
                                              width: '100%',
                                              marginBottom: '10px',
                                            }}
                                            label='Feedback'
                                          />
                                        </Grid>
                                      </TableCell>
                                    </TableBody>
                                  );
                                })}
                              </Table>
                              <Table
                                style={{
                                  display: isSmallDevice ? 'table' : 'none',
                                }}
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell>
                                      <Typography>Actions </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography>Name </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography>
                                        {reportFields[0]?.report_name}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Grid size={{ xs: 12, md: 12 }}>
                                        <Checkbox
                                          sx={{ marginLeft: '-15px' }}
                                          checked={checkAll}
                                          onChange={(e) =>
                                            handleSelectAll(e, setFieldValue)
                                          }
                                        />
                                      </Grid>
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                {signUpUsers.map((element, ind) => {
                                  return (
                                    <TableBody key={element.id}>
                                      <TableRow>
                                        <TableCell>
                                          <Grid container spacing={2}>
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                              }}
                                            >
                                              <IconButton
                                                size='small'
                                                className='icon-btn'
                                                onClick={() =>
                                                  handleDelete(
                                                    element.id,
                                                    sessionId,
                                                    productId,
                                                  )
                                                }
                                              >
                                                <AiOutlineDelete />
                                              </IconButton>
                                            </div>
                                          </Grid>
                                        </TableCell>
                                        <TableCell
                                          colSpan={2}
                                          sx={{ textAlign: 'left' }}
                                        >
                                          <Typography>
                                            <span className='wordbreak'>
                                              {element?.first_name}&nbsp;
                                              {element?.last_name}
                                            </span>
                                          </Typography>
                                        </TableCell>
                                        <TableCell sx={{ width: '30px' }}>
                                          <Grid size={{ xs: 12, md: 12 }}>
                                            <FormControlLabel
                                              control={
                                                <Field
                                                  component={Checkbox}
                                                  type='checkbox'
                                                  name={`is_attended${ind}`}
                                                  id={`is_attended${ind}`}
                                                  onChange={(e) => {
                                                    const isChecked =
                                                      e.target.checked;
                                                    setFieldValue(
                                                      `is_attended[${ind}].is_attended${ind}`,
                                                      e.target.checked,
                                                    );
                                                    handleChangeAllAttendence(
                                                      element.id,
                                                      e.target.checked,
                                                    );
                                                    setCheckAll(
                                                      isChecked
                                                        ? checkAll
                                                        : false,
                                                    );
                                                  }}
                                                  checked={
                                                    values.is_attended[ind]
                                                      ? values.is_attended[ind][
                                                          `is_attended${ind}`
                                                        ]
                                                      : false
                                                  }
                                                />
                                              }
                                            />
                                          </Grid>
                                        </TableCell>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell
                                          colSpan={4}
                                          sx={{ borderBottom: 'none' }}
                                        >
                                          <Grid container spacing={2}>
                                            {reportFields?.map((field, index) =>
                                              renderField(
                                                field,
                                                index,
                                                ind,
                                                element,
                                                setFieldValue,
                                                values,
                                              ),
                                            )}
                                          </Grid>

                                          <Grid
                                            size={{ xs: 12, md: 12 }}
                                            style={{ marginTop: '10px' }}
                                          >
                                            <TextField
                                              name={`feedback.${ind}`}
                                              value={values?.feedback?.[ind]}
                                              onChange={(e) =>
                                                handleFeedbackChange(
                                                  e,
                                                  ind,
                                                  element,
                                                  setFieldValue,
                                                )
                                              }
                                              variant='outlined'
                                              sx={{
                                                width: '100%',
                                                marginBottom: '10px',
                                              }}
                                              label='Feedback'
                                            />
                                          </Grid>
                                        </TableCell>
                                      </TableRow>
                                    </TableBody>
                                  );
                                })}
                              </Table>
                            </Grid>
                            <Grid size={{ xs: 12, md: 12 }}>
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                {signUpUsers.length > 0 ? (
                                  <Button
                                    sx={{
                                      position: 'relative',
                                      minWidth: 100,
                                      backgroundColor: companyTheme
                                        ? companyTheme.primary.main
                                        : '#2196f3',
                                      '&:hover': {
                                        backgroundColor: companyTheme
                                          ? alpha(
                                              companyTheme.primary.main,
                                              0.8,
                                            ) // Adjust the alpha value as needed
                                          : alpha('#2196f3', 0.8),
                                      },
                                    }}
                                    disabled={loading || isSubmitting}
                                    variant='contained'
                                    type='submit'
                                  >
                                    <IntlMessages id='common.save' />
                                  </Button>
                                ) : (
                                  ''
                                )}
                                <Button
                                  sx={{
                                    position: 'relative',
                                    minWidth: 100,
                                    ml: 2.5,
                                    borderColor: companyTheme
                                      ? companyTheme.primary.main
                                      : '#2196f3',
                                    '&:hover': {
                                      borderColor: companyTheme
                                        ? alpha(companyTheme.primary.main, 0.8)
                                        : alpha('#2196f3', 0.8),
                                    },
                                    color: companyTheme
                                      ? companyTheme.primary.main
                                      : '#2196f3',
                                  }}
                                  variant='outlined'
                                  disabled={loading || isSubmitting}
                                  onClick={handleDialogOpen}
                                >
                                  <IntlMessages id='common.cancel' />
                                </Button>
                              </Box>
                            </Grid>
                          </AppGridContainer>
                        </Box>
                      </Grid>
                    </AppGridContainer>
                  </Form>
                );
              }}
            </Formik>
          </Box>
        </Modal>
      )}
      <Dialog
        open={deleteConfirmationOpen}
        onClose={handleCancelDelete}
        maxWidth='xs'
      >
        <DialogTitle>
          <Typography variant='h4'>Confirm Deletion</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ fontSize: '16px', fontWeight: 'bold' }}>
            Are you sure you want to delete this user from this session?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmDelete} color='primary'>
            Yes
          </Button>
          <Button onClick={handleCancelDelete} color='secondary'>
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={creditWarningOpen}
        onClose={() => setCreditWarningOpen(false)}
        maxWidth='xs'
      >
        <DialogTitle>
          <Typography variant='h4'>Credit Warning</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ fontSize: '16px', fontWeight: 'bold' }}>
            {creditWarningMessage}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setCreditWarningOpen(false)}
            color='secondary'
            variant='outlined'
          >
            Cancel
          </Button>
          {isAdminUser(user) && (
            <Button
              onClick={performMemberSessionSignup}
              sx={{
                position: 'relative',
                minWidth: 100,
                backgroundColor: companyTheme
                  ? companyTheme.primary.main
                  : '#2196f3',
                '&:hover': {
                  backgroundColor: companyTheme
                    ? alpha(companyTheme.primary.main, 0.8) // Adjust the alpha value as needed
                    : alpha('#2196f3', 0.8),
                },
              }}
              variant='contained'
            >
              Add user
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <AppModalConfirmation
        openDialog={openDialog}
        handleCloseDialog={handleCloseDialog}
        handleCloseModalDialog={handleCloseModalDialog}
      />
    </>
  );
};
export default AddAttendance;
AddAttendance.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  activityData: PropTypes.object,
  sessionId: PropTypes.string,
  productId: PropTypes.number,
  fetchAttendanceData: PropTypes.func,
  isFetch: PropTypes.bool,
  reportId: PropTypes.object,
  attendanceData: PropTypes.array,
  fetchData: PropTypes.func,
  fetchSignUpUsers: PropTypes.func,
  signUpUsers: PropTypes.array,
  setPerPage: PropTypes.func,
  handleReportsData: PropTypes.func,
};
